import React, { useState } from 'react'
import ReceptionTab from './ReceptionTab'
import ReportingTab from './ReportingTab'
import ResultsTab from './ResultsTab'

type TabType = 'reception' | 'reporting' | 'results'

const UnifiedWorklist: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabType>('reception')

  const tabs = [
    {
      id: 'reception' as TabType,
      label: '📋 Tiếp nhận',
      description: 'Bệnh nhân cần upload ảnh slide'
    },
    {
      id: 'reporting' as TabType,
      label: '📝 Tạo phiếu',
      description: 'Bệnh nhân đã có ảnh, cần tạo phiếu kết quả'
    },
    {
      id: 'results' as TabType,
      label: '📄 Phiếu kết quả',
      description: 'Phiếu đã tạo, cần hoàn thành và trả kết quả'
    }
  ]

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Worklist - Danh sách Công việc</h1>
        <p className="mt-1 text-sm text-gray-600">
          Quản lý quy trình xử lý mẫu từ tiếp nhận đến trả kết quả
        </p>
      </div>

      {/* Tabs */}
      <div className="mb-6 border-b border-gray-200">
        <nav className="-mb-px flex space-x-8" aria-label="Tabs">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`
                whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm
                ${
                  activeTab === tab.id
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }
              `}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      {/* Tab Description */}
      <div className="mb-4 bg-blue-50 border-l-4 border-blue-400 p-4">
        <p className="text-sm text-blue-700">
          {tabs.find(t => t.id === activeTab)?.description}
        </p>
      </div>

      {/* Tab Content */}
      <div className="mt-4">
        {activeTab === 'reception' && <ReceptionTab />}
        {activeTab === 'reporting' && <ReportingTab />}
        {activeTab === 'results' && <ResultsTab />}
      </div>
    </div>
  )
}

export default UnifiedWorklist
